// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoRespiratorioCs {
    fecha={}
    lista=[
        {
            encabezado:"1. Información personal y laboral",
            datos:[
                {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Tiene contacto de la piel o la ropa con sustancias químicas de uso predominante en el trabajo:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"(especifique):"},
                {valor:"", descripcion:"", tipo:1 ,label:"c. La exposición a estas sustancias es:",data:["Diaria","Semanal","Una o dos veces al mes","N/A"]},
                {valor:"", descripcion:"", tipo:0 ,label:"d. Otras exposiciones en el trabajo a procesos peligrosos que podrían afectar a la piel:" },
                {valor:"", descripcion:"", tipo:1 ,label:"Frio",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Calor",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Sol",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Radiaciones ionizantes",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Vibraciones",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"e. Usa guantes de:" },
                {valor:"", descripcion:"", tipo:1 ,label:"Caucho",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Cuero",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Latex",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Nitrilo",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Poliuretano",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Neopreno",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. ¿Usa cremas protectoras para las manos?",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"g. ¿Con qué se lava las manos? :",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Jabón",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Detergente",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Desinfectantes",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Gasolina",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Thinner",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Cremas",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. Por fuera del trabajo ¿está expuesto a sustancias químicas líquidas o sólidas (metales, solventes, resinas, cemento, desodorantes, perfumes, cremas, maquillajes)?",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"i. Valoración instrumental químicos (HCU):"},
                {valor:"", descripcion:"", tipo:4 ,label:"j. Valoración instrumental temperatura (HCU):"},
            ]
        },
        {
            encabezado:"2. Antecedentes de trastornos de la piel y otras relacionadas",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. ¿Ha tenido alguna enfermedad de la piel?:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"b. Si la respuesta es positiva, indique cuál de las siguientes:" },
                {valor:"", descripcion:"", tipo:1 ,label:"Eczema" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Dermatitis irritativas" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Dermatitis alérgicas" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Quemaduras",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Trastornos del color",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Tumores",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. ¿Recibió tratamiento?",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:0 ,label:"d. Si la respuesta es positiva, indique:" },
                {valor:"", descripcion:"", tipo:3 ,label:"¿Qué tipo de tratamiento?"},
                {valor:"", descripcion:"", tipo:1 ,label:"¿Ha notado cambios con el tratamiento recibido?:",data:["Mejoró","Empeoró","No se modifica","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. ¿Le han hecho prueba del parche?:",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:4 ,label:"f. Si la respuesta es positiva, indique los resultados:"},
                {valor:"", descripcion:"", tipo:1 ,label:"g. ¿Sufre de alergias de cualquier tipo?:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"h. Si la respuesta es positiva, indique tipo y lugar del cuerpo:"},
            ]
        },
        {
            encabezado:"3. Antecedentes familiares cercanos (padre, madre, hermanos) con patología de la piel",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. ¿Algún familiar tiene enfermedades de la piel?:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"b. Si la respuesta es positiva, indique ¿cuál? :"},
                {valor:"", descripcion:"", tipo:3 ,label:"¿Quiénes? :"},
                {valor:"", descripcion:"", tipo:1 ,label:"c. ¿Algún familiar cercano (padre, madre, hermanos) tiene alergias de cualquier tipo?:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"d. Si la respuesta es positiva, indique tipo y lugar del cuerpo:"},
                {valor:"", descripcion:"", tipo:3 ,label:"¿Quiénes? :"}
            ]
        },
        {
            encabezado:"4. Sintomatología dérmica actual",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. ¿Tiene alguna alteración de la piel?:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:4 ,label:"b. Si la respuesta es positiva, describa (síntomas, localización):"},
                {valor:"", descripcion:"", tipo:1 ,label:"c. ¿Hay alguna relación con el trabajo?:", data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:4 ,label:"Describa:"},
                {valor:"", descripcion:"", tipo:1 ,label:"d. ¿Recibe actualmente algún tratamiento?:", data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:4 ,label:"e. Si la respuesta es positiva, indique cuál:"},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Ha notado cambios con el tratamiento recibido:", data:["Mejoró","Empeoró","No se modifica","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Las alteraciones de la piel aparecen o aumentan con el uso en casa de perfumes, desodorantes, cremas, anillos, reloj, cadenas, aretes:", data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:4 ,label:"h. Si la respuesta es positiva, especifique:"},
                {valor:"", descripcion:"", tipo:1 ,label:"i. Qué pasa con las alteraciones de la piel el fin de semana:", data:["Desaparece","Mejoran","Empeoran","No se Modifican","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"j. ¿Tiene compañeros de trabajo que sufren el mismo problema suyo?:", data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:3 ,label:"k. Si la respuesta es positiva, indique el área de trabajo:"},
            ]
        },
        {
            encabezado:"5. Exploración física",
            datos:[
                {valor:"", descripcion:"", tipo:0 ,label:"a. Tipo de lesión:"},
                {valor:"", descripcion:"", tipo:1 ,label:"Eritema",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:11, imagen:1 },
                {valor:"", descripcion:"", tipo:1 ,label:"Mácula",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:11, imagen:2 },
                {valor:"", descripcion:"", tipo:1 ,label:"Vesículas",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:11, imagen:3 },
                {valor:"", descripcion:"", tipo:1 ,label:"Escamas",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:11, imagen:4 },
                {valor:"", descripcion:"", tipo:1 ,label:"Fisuras",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:11, imagen:5 },
                {valor:"", descripcion:"", tipo:3 ,label:"b. Número y tamaño:"},
                {valor:"", descripcion:"", tipo:3 ,label:"c. Ubicación:"},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Signos de rascado prurito:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. ¿Se calculó el nivel de exposición global dérmica (NEGD)? (Ver instructivo):",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"f. Si la respuesta es positiva, registre el resultado:"}
            ]
        },
        {
            encabezado:"6. Ha recibido capacitaciones sobre ...",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"Substancias químicas que afectan a la piel" ,data:["Frecuentemente","Rara vez","Nunca"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Alteraciones de la piel por el trabajo" ,data:["Frecuentemente","Rara vez","Nunca"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Medidas de protección para la piel" ,data:["Frecuentemente","Rara vez","Nunca"]},
            ]
        },
        {
            encabezado:"7. Conclusiones del estado de salud",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:""},
            ]
        },
        {
            encabezado:"8. Recomendaciones en el campo de la salud (seguimiento, interconsulta, medidas de protección, capacitación)",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:""}
            ]
        }
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoDermatológicoCs.js